import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PublicComponent } from './public.component';
import { IsAuthenticatedResolver } from '../accounts/login/is-authenticated-resolver.service';
import { LanguageResolver } from '../shared/language.resolver';
import { LoginComponent } from '../accounts/login/login.component';
import { LogoutComponent } from '../accounts/logout/logout.component';
import { ResetComponent } from '../accounts/reset/reset.component';
import { RegisterComponent } from '../accounts/register/register.component';
import { ReferralResolver } from '../referrals/referral.resolver';

export const routes: Routes = [
  {
    path: '',
    component: PublicComponent,
    children: [
      {
        path: 'login',
        component: LoginComponent,
        resolve: {
          isAuthenticated: IsAuthenticatedResolver,
        },
      },
      {
        path: 'logout',
        component: LogoutComponent,
      },
      {
        path: 'reset',
        component: ResetComponent,
      },
      {
        path: 'signup',
        component: RegisterComponent,
      },
      {
        path: 'public',
        loadChildren: () =>
          import('../document-view-public/document-view-public.module')
            .then((m) => m.DocumentViewPublicModule),
      },
      {
        path: '',
        loadChildren: () =>
          import('../error-pages/error-pages.module').then(
            (m) => m.ErrorPagesModule,
          ),
      },
    ],
    resolve: {
      l: LanguageResolver,
      ref: ReferralResolver,
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [IsAuthenticatedResolver],
})
export class PublicRoutingModule {}
